import { Box } from "@mui/material";
import React, { useMemo } from "react";
import SenderInfo from "./SenderInfo";
import FileUpload from "./FileUpload";
import ContentTemplates from "./ContentTemplates";
import Message from "./Message";
import {
  ICampaignSenderDetails,
  IMediaDetails,
  ITemplate,
  ITemplatePlaceholderValues,
  TApiStatus,
  EMediaType,
  IErrors,
} from "../../../../../types/campaign.types";
import { FetchBaseQueryError, QueryStatus } from "@reduxjs/toolkit/dist/query";
import { SerializedError } from "@reduxjs/toolkit";

export interface ITemplateDetails {
  selectedTemplate: ITemplate | null;
  handleUpdateSelectedTemplate: (template: ITemplate | null) => void;
  templates: ITemplate[];
  fetchStatus: TApiStatus;
}

export interface IPlaceholderFetchStatusDetails {
  status: QueryStatus;
  error: FetchBaseQueryError | SerializedError | undefined;
}

export interface IMediaPropsDetails {
  handleUpdateMediaDetails: (mediaDetails: IMediaDetails) => void;
  addMediaFlag: boolean;
  mediaType: EMediaType;
  uploadedFile: File | null;
  fileName: string;
  fileSize: string;
  error: string;
  handleErrors: (newErrors: IErrors) => void;
}
interface IProps {
  senderDetails: ICampaignSenderDetails;
  mediaDetails: IMediaPropsDetails;
  templateDetails: ITemplateDetails;
  placeholdersDetails: ITemplatePlaceholderValues;
  placeholderFetchStatusDetails: IPlaceholderFetchStatusDetails;
}

const MiddleSection: React.FC<IProps> = ({
  senderDetails,
  mediaDetails,
  templateDetails,
  placeholdersDetails,
  placeholderFetchStatusDetails,
}) => {
  const finalTemplates = useMemo(() => {
    if (!mediaDetails?.addMediaFlag) {
      return (
        templateDetails?.templates?.filter(
          (item) => item.type?.toLowerCase() === EMediaType.TEXT
        ) || []
      );
    }

    if (mediaDetails?.mediaType === EMediaType.DOCUMENT) {
      return (
        templateDetails?.templates?.filter(
          (item) => item.type?.toLowerCase() === EMediaType.DOCUMENT
        ) || []
      );
    }

    if (mediaDetails?.mediaType === EMediaType.IMAGE) {
      return (
        templateDetails?.templates?.filter(
          (item) => item.type?.toLowerCase() === EMediaType.IMAGE
        ) || []
      );
    }
    return [];
  }, [
    mediaDetails?.addMediaFlag,
    mediaDetails?.mediaType,
    templateDetails?.templates,
  ]);

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <SenderInfo senderDetails={senderDetails} />

      <FileUpload
        handleUpdateMediaDetails={mediaDetails.handleUpdateMediaDetails}
        addMediaFlag={mediaDetails.addMediaFlag}
        mediaType={mediaDetails.mediaType}
        uploadedFile={mediaDetails.uploadedFile}
        fileName={mediaDetails.fileName}
        fileSize={mediaDetails.fileSize}
        error={mediaDetails.error}
        handleErrors={mediaDetails.handleErrors}
      />

      <ContentTemplates
        handleUpdateSelectedTemplate={
          templateDetails.handleUpdateSelectedTemplate
        }
        selectedTemplate={templateDetails.selectedTemplate}
        templates={finalTemplates}
        fetchStatus={templateDetails.fetchStatus}
      />

      <Message
        message={templateDetails.selectedTemplate?.content || ""}
        placeholders={placeholdersDetails}
        placeholderFetchStatusDetails={placeholderFetchStatusDetails}
      />
    </Box>
  );
};

export default React.memo(MiddleSection);
